type RentalPeriod = {
  from: Date;
  to: Date;
};

type RentalRates = {
  dailyRentalPrice: number;
  weeklyRentalPrice: number;
  monthlyRentalPrice: number;
};

type Response = {
  subTotal: number;
  discount: number;
  tax: number;
  total: number;
};

export function calculateRentalPrice(period: RentalPeriod, rates: RentalRates, tax: number): Response {
  const { from, to } = period;
  const { dailyRentalPrice, weeklyRentalPrice, monthlyRentalPrice } = rates;

  // Calculate the total days in the rental period
  const totalDays = (to.getTime() - from.getTime()) / (1000 * 3600 * 24) + 1;

  let remainingDays = totalDays;
  const remainingMonths = Math.max(Math.floor(totalDays / 30), 0);
  remainingDays -= remainingMonths * 30;
  const remainingWeeks = Math.max(Math.floor(remainingDays / 7), 0);
  remainingDays -= remainingWeeks * 7;

  const price =
    remainingMonths * monthlyRentalPrice + remainingWeeks * weeklyRentalPrice + remainingDays * dailyRentalPrice;

  return {
    subTotal: totalDays * dailyRentalPrice,
    discount: totalDays * dailyRentalPrice - price,
    tax: price * (tax / 100),
    total: price
  };
}
